import { render, staticRenderFns } from "./layout-default-messangers.vue?vue&type=template&id=0283608a&"
import script from "./layout-default-messangers.vue?vue&type=script&lang=js&"
export * from "./layout-default-messangers.vue?vue&type=script&lang=js&"
import style0 from "./layout-default-messangers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports